import Axios from 'axios';
import vuex from '@/store';
import storage from '@/xstorage';

const axios = Axios.create({
  baseURL: `https://${process.env.VUE_APP_ENDPOINT_SERVICES_PROXY}/api/services-new`
});

axios.interceptors.request.use(async config => {
  const token = await storage.getToken();
  if (token)
    config.headers.Authorization = token;

  return config;
}, error => {
  return Promise.reject(error);
});

axios.interceptors.response.use(response => {
  return response;
}, error => {

  if (error.response) {

    // logout user if we specifically receive an unauthorized response saying we have expired
    if (error.response.status === 403 && error.response.data.status === 'expired') {
      console.log('Oops, your session expired.\n', error);
      vuex.dispatch('account/expire');
    }

    // if we receive a response with a 500 error log the error message
    if (error.response.status === 500) {
      console.log('Oops, something went wrong.\n', error);
      vuex.dispatch('alert/error', error);
    }

  } else {
    // if we don't even receive a response, log the entire error object
    console.log('Oops, something went horribly wrong.\n', error);
    vuex.dispatch('alert/error', error);
  }

  return Promise.reject(error);
});

export default axios;